export default __webpack_public_path__ + "static/media/user.37aeba2d.png";